import * as React from 'react';
import { Component } from 'react';
import styles from '../../styles/flyouts/products/Files.scss';
import * as _ from 'lodash';
import classNames from 'classnames';
import ArrowDownMiddleIcon from '../../assets/images/arrow-down-middle-15x15.svg';
import autobind from 'autobind-decorator';
import {
  __,
  bytesToSize,
  dateFrom,
  getActiveStage,
  mapStateToProps,
  setTableParams,
  timeFrom,
} from '../../core/utils';
import { setNotification } from '../../redux/actions/general/notification';
import {
  readProduct,
  uploadProductFiles,
} from '../../redux/actions/table/products';
import {
  hideAlertbox,
  showAlertbox,
} from '../../redux/actions/general/alertbox';
import ReactDropzone from 'react-dropzone';
import UploadIcon from '../../assets/images/upload-40x40.svg';
import DeleteIcon from '../../assets/images/delete-15x15.svg';
import { Form, getFormValues, reduxForm } from 'redux-form';
import Select from '../../components/Select';
import Images from './Images';
import FilePreview from '../../components/FilePreview';
import Avatar from '../../components/Avatar';
import { hideDropdown } from '../../redux/actions/general/dropdown';
import {
  archiveAttachment,
  deleteAttachmentCurrentVersion,
  unarchiveAttachment,
} from '../../redux/actions/attachments';
import AttachmentFileMenu from '../../components/AttachmentFileMenu';
import { setAttachmentParams } from '../../redux/actions/general/attachments';
import Dropdown from '../../components/Dropdown';
import { linkFilesToModel } from '../../redux/actions/table/files';

@reduxForm({
  form: 'products.files',
  enableReinitialize: true,
})
@mapStateToProps((state) => ({
  flyout: state.table.products.flyout,
}))
class Files extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: [],
      files: [],
      active_category: null,
      category_errors: null,
      showArchivedFiles: false,
    };
  }

  componentDidMount() {
    const { files, images } = this.props.flyout;

    this.setState({
      expanded: _.map([...files, ...images], (file) => file.category),
    });

    window.addEventListener('paste', this._handlePaste);
  }

  componentWillUnmount() {
    window.removeEventListener('paste', this._handlePaste);
  }

  @autobind
  _handlePaste(event) {
    const files = event.clipboardData.files;

    this.setState({
      files: [
        ..._.values(this.state.files),
        ..._.map(files, (file) => {
          return {
            file: Object.assign(file, {
              stream_url: URL.createObjectURL(file),
              ext: file.name.split('.').pop(),
            }),
            category: '',
          };
        }),
      ],
    });

    this.props.change('files', files);
  }

  @autobind
  _toggleCollapseCategory(category) {
    this.setState({
      expanded: _.xor(this.state.expanded, [category]),
    });
  }

  @autobind
  _uploadFiles(category, files) {
    const product_id = this.props.flyout.id;
    const stage_id = getActiveStage();
    const uploadedFiles = _.reject(this.state.files, 'linked_attachment');
    const linkedFiles = _.filter(this.state.files, 'linked_attachment');
    const actions = _.compact([
      !_.isEmpty(uploadedFiles) && uploadProductFiles(product_id, uploadedFiles),
      !_.isEmpty(linkedFiles) &&
        linkFilesToModel(
          stage_id,
          'Product',
          product_id,
          _.map(linkedFiles, (row) => ({
            id: row.attachment_id,
            category: row.category,
          }))
        ),
    ]);

    setNotification(
      __('products.flyout.files-being-uploaded.please-wait.notification')
    );

    Promise.all(actions)
      .then(() => {
        readProduct(product_id).then(({ response }) => {
          setTableParams('products', {
            flyout: response.data,
          });
        });

        this.setState({
          files: [],
          category_errors: null,
          active_category: null,
        });
      })
      .catch((error) => {
        this.setState({
          category_errors: _.map(
            Object.keys(_.get(error, 'response.errors', {})),
            (key) => _.toNumber(_.first(key.match(/\d+/)))
          ),
        });

        setNotification({
          text: __(
            'products.flyout.files.cant-upload-file.doublecheck-file-size-format.warning'
          ),
          type: 'warning',
        });
      });
  }

  @autobind
  _downloadFile({ download_url }) {
    setNotification(
      __('products.flyout.files.products.files.download.continue')
    );

    window.open(download_url, '_blank');
  }

  @autobind
  _refreshProduct() {
    const product_id = this.props.flyout.id;

    return readProduct(product_id).then(({ response }) => {
      setTableParams('products', {
        flyout: response.data,
      });

      return response.data;
    });
  }

  @autobind
  _openEditAttachment(row) {
    hideDropdown();

    setAttachmentParams({
      edit_attachment_wizard: row,
      attachment_context: {
        type: 'product',
        product_id: this.props.flyout.id,
      },
    });

  }

  @autobind
  _openUploadAttachmentVersion(row) {
    hideDropdown();

    setAttachmentParams({
      upload_attachment_version_wizard: row,
      attachment_context: {
        type: 'product',
        product_id: this.props.flyout.id,
      },
    });

  }

  @autobind
  _archiveAttachment(row) {
    const is_archived = !!row.archived;
    const update_archive = is_archived
      ? unarchiveAttachment
      : archiveAttachment;

    hideDropdown();

    showAlertbox({
      color: 'blue',
      title: __('general.alert.are-you-sure'),
      description: is_archived
        ? __(
            'attachments.alert.unarchive-file',
            {},
            'Are you sure you want to unarchive this file?'
          )
        : __(
            'attachments.alert.archive-file',
            {},
            'Are you sure you want to archive this file?'
          ),
      buttons: [
        {
          color: 'lightGray',
          text: __('general.alert.no-close'),
          onClick: 'close',
        },
        {
          color: 'gray',
          text: is_archived
            ? __('attachments.button.unarchive', {}, 'Unarchive')
            : __('attachments.button.archive', {}, 'Archive'),
          onClick: () => {
            update_archive(row.attachment_id).then(() => {
              hideAlertbox();
              setNotification(
                is_archived
                  ? __(
                      'attachments.notification.unarchived',
                      {},
                      'File unarchived.'
                    )
                  : __(
                      'attachments.notification.archived',
                      {},
                      'File archived.'
                    )
              );
              this._refreshProduct();
            });
          },
        },
      ],
    });
  }

  @autobind
  _deleteFile(row) {
    hideDropdown();

    showAlertbox({
      color: 'red',
      title: __('general.alert.are-you-sure'),
      description: __(
        'products.flyout.files.are-you-sure.remove-file.products.alert'
      ),
      buttons: [
        {
          color: 'lightGray',
          text: __('general.alert.no-close'),
          onClick: 'close',
        },
        {
          color: 'gray',
          text: __('general.alert.yes-delete'),
          onClick: () => {
            deleteAttachmentCurrentVersion(row.attachment_id).then(() => {
              hideAlertbox();

              setNotification(
                __(
                  'products.flyout.files.file-has-been-deleted.products.notification'
                )
              );

              this._refreshProduct();
            });
          },
        },
      ],
    });
  }

  @autobind
  _handleDrop(acceptedFiles, rejectedFiles) {
    this.setState({ drag: false });

    if (!_.isEmpty(acceptedFiles)) {
      if (_.size(rejectedFiles) > 1) {
        setNotification({
          text: __('specifications.files.upload.bulk-not-allowed'),
          type: 'warning',
        });
      } else if (!_.isEmpty(rejectedFiles)) {
        setNotification({
          text: __('specifications.files.upload.incorrect.format'),
          type: 'warning',
        });
      } else if (
        _.find(acceptedFiles, (file) => {
          return file.size >= 312857600;
        })
      ) {
        setNotification({
          text: __('specifications.files.upload.upload-limit'),
          type: 'warning',
        });
      } else {
        this.setState({
          files: [
            ..._.values(this.state.files),
            ..._.map(acceptedFiles, (file) => {
              return {
                file: Object.assign(file, {
                  stream_url: URL.createObjectURL(file),
                  ext: file.name.split('.').pop(),
                }),
                category: '',
              };
            }),
          ],
        });

        this.props.change('files', acceptedFiles);
      }
    }
  }

  @autobind
  _normalizeLinkedFile(file) {
    return {
      linked_attachment: true,
      attachment_id: file.id,
      category: '',
      file: {
        ...file,
        attachment_id: file.id,
        stream_url: file.stream_url || file.thumbnail_url,
        name: file.name || file.file_name,
        ext: file.ext || file.extension,
        current_version_created_at:
          file.current_version_created_at || file.uploaded_at,
        created_at: file.created_at || file.uploaded_at,
      },
    };
  }

  @autobind
  _openLinkExistingFilesWizard() {
    const { flyout } = this.props;
    const stage_id = getActiveStage();

    hideDropdown();
    setAttachmentParams({
      link_existing_files_wizard: {
        stage_id,
        linked_file_ids: [
          ..._.map([...flyout.files, ...flyout.images], 'attachment_id'),
          ..._.map(
            _.filter(this.state.files, 'linked_attachment'),
            'attachment_id'
          ),
        ],
        showSuccessNotification: false,
        onLinkFiles: (file_ids, selectedFiles) => {
          const selectedFileIds = new Set(file_ids);
          const nextFiles = [
            ..._.values(this.state.files),
            ..._.map(
              _.filter(selectedFiles, (file) =>
                selectedFileIds.has(Number(file.id))
              ),
              this._normalizeLinkedFile
            ),
          ];

          this.setState({
            files: _.uniqBy(nextFiles, (row, index) =>
              row.linked_attachment
                ? 'linked_' + row.attachment_id
                : 'uploaded_' + index
            ),
          });

          return Promise.resolve();
        },
      },
    });
  }

  @autobind
  _openUploadPicker() {
    hideDropdown();

    if (this.dropzone) {
      this.dropzone.open();
    }
  }

  render() {
    const { collapsed, flyout } = this.props;
    const { expanded, showArchivedFiles } = this.state;
    const allAttachments = [...flyout.files, ...flyout.images];
    const archivedFilesCount = _.size(
      _.filter(allAttachments, (file) => file.archived)
    );
    const visibleAttachments = showArchivedFiles
      ? allAttachments
      : _.filter(allAttachments, (file) => !file.archived);

    const categories = [
      {
        label: __('products.flyout.files.thumbnail'),
        value: 'thumbnail',
      },
      {
        label: __('products.flyout.files.product'),
        value: 'product',
      },
      {
        label: __('products.flyout.files.drawing'),
        value: 'drawing',
      },
      {
        label: __('products.flyout.files.ambient'),
        value: 'ambient',
      },
      {
        label: __('products.flyout.files.technical'),
        value: 'technical',
      },
      {
        label: __('products.flyout.files.tileable-texture-for-3d'),
        value: 'tileable',
      },
      {
        label: __('products.flyout.files.manuals'),
        value: 'manuals',
      },
      {
        label: __('products.flyout.files.datasheets'),
        value: 'datasheets',
      },
      {
        label: __('products.flyout.files.guarantee'),
        value: 'guarantee',
      },
      {
        label: __('products.flyout.files.certificates'),
        value: 'certificates',
      },
      {
        label: __('products.flyout.files.catalogs'),
        value: 'catalogs',
      },
      {
        label: __('products.flyout.files.installation'),
        value: 'installation',
      },
      {
        label: __('products.flyout.files.bim'),
        value: 'bim',
      },
      {
        label: __('products.flyout.files.3d'),
        value: '3d',
      },
      {
        label: __('products.flyout.files.cad'),
        value: 'cad',
      },
      {
        label: __('products.flyout.files.2d'),
        value: '2d',
      },
      {
        label: __('products.flyout.files.photometrical-distribution'),
        value: 'light_data',
      },
      {
        label: __('products.flyout.files.video'),
        value: 'video',
      },
      {
        label: __('products.flyout.files.audio'),
        value: 'audio',
      },
      {
        label: __('products.flyout.files.other'),
        value: 'other',
      },
    ];

    const { files, category_errors, active_category } = this.state;

    const lightbox_files = _.map(
      _.filter(files, (row) =>
        _.includes(['jpg', 'jpeg', 'png'], _.toLower(row.file.ext))
      ),
      (row) => ({
        id: row.file.id,
        attachment_version_id: row.file.attachment_version_id,
        stream_url: row.file.stream_url,
        title: [row.file.name, row.file.ext].join('.'),
      })
    );

    return (
      <div
        className={classNames(styles.wrapper, collapsed && styles.collapsed)}
      >
        {!_.isEmpty(allAttachments) && (
          <div className={styles.actions}>
            <label className={styles.showArchivedFiles}>
              {archivedFilesCount > 0 ? (
                <>
                  <span>
                    {__('products.flyout.files.show-hide-archived-files')}{' '}
                    {'(' + archivedFilesCount + ')'}
                  </span>
                  <input
                    type='checkbox'
                    checked={showArchivedFiles}
                    onChange={(e) =>
                      this.setState({ showArchivedFiles: e.target.checked })
                    }
                  />
                </>
              ) : (
                <span>{__('products.flyout.files.no-archived-files')}</span>
              )}
            </label>
          </div>
        )}
        {/* Files list */}
        {_.map(categories, (category) => {
          const category_files = _.filter(
            visibleAttachments,
            ['category', category.value]
          );

          const lightbox_images = _.map(
            _.filter(category_files, (file) =>
              _.includes(['jpg', 'jpeg', 'png', 'pdf'], _.toLower(file.ext))
            ),
            (file) => ({
              id: file.id,
              attachment_version_id: file.attachment_version_id,
              stream_url: file.stream_url,
              title: [file.name, file.ext].join('.'),
              download_url: file.download_url,
              ext: file.ext,
              width: file.width,
              height: file.height,
            })
          );

          return (
            <>
              {!_.isEmpty(category_files) && (
                <div className={styles.category} key={category.value}>
                  <div
                    className={styles.title}
                    onClick={() => this._toggleCollapseCategory(category.value)}
                  >
                    <ArrowDownMiddleIcon
                      className={classNames(
                        styles.collapse,
                        !_.includes(expanded, category.value) &&
                          styles.collapsed
                      )}
                    />
                    {category.label}{' '}
                    {!_.isEmpty(category_files) &&
                      '(' + _.size(category_files) + ')'}
                  </div>
                  {_.includes(expanded, category.value) &&
                    (_.includes(
                      [
                        'thumbnail',
                        'product',
                        'drawing',
                        'ambient',
                        'technical',
                        'tileable',
                      ],
                      category.value
                    ) ? (
                      <Images
                        data={category_files}
                        category={category.value}
                      />
                    ) : (
                      !_.isEmpty(category_files) && (
                        <div className={styles.files}>
                          {_.map(category_files, (file, index) => {
                            return (
                              <div
                                className={classNames(
                                  styles.file,
                                  file.archived && styles.archived
                                )}
                                key={file.attachment_id || file.id}
                              >
                                <div className={styles.left}>
                                  <FilePreview
                                    onDownloadFile={this._downloadFile}
                                    row={file}
                                    lightbox_images={lightbox_images}
                                  />
                                </div>

                                <div className={styles.right}>
                                  <span className={styles.version}>
                                    {'V' + file.version}
                                  </span>

                                  <span className={styles.size}>
                                    {bytesToSize(file.size)}
                                  </span>

                                  {file.creator && (
                                    <div className={styles.avatar}>
                                      <Avatar
                                        size={24}
                                        {...file.creator}
                                        avatar_url={file.creator.avatar_url}
                                      />
                                    </div>
                                  )}

                                  <div className={styles.date_time}>
                                    {dateFrom(
                                      file.current_version_created_at ||
                                        file.created_at
                                    )}
                                    <br />
                                    {timeFrom(
                                      file.current_version_created_at ||
                                        file.created_at
                                    )}
                                  </div>

                                  <div className={styles.icons}>
                                    <AttachmentFileMenu
                                      name={
                                        'product_file_menu_' +
                                        category.value +
                                        '_' +
                                        index +
                                        '_' +
                                        (file.attachment_id || file.id)
                                      }
                                      row={file}
                                      onDownloadFile={this._downloadFile}
                                      onOpenEdit={this._openEditAttachment}
                                      onOpenUploadVersion={
                                        this._openUploadAttachmentVersion
                                      }
                                      onArchiveAttachment={
                                        this._archiveAttachment
                                      }
                                      onDeleteFile={this._deleteFile}
                                    />
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )
                    ))}
                </div>
              )}
            </>
          );
        })}

        {/* Dropzone - upload files */}
        <ReactDropzone
          ref={(dropzone) => {
            this.dropzone = dropzone;
          }}
          className={classNames(
            styles.dropzone,
            _.get(this.state, 'drag') && styles.drag
          )}
          disableClick
          onDrop={this._handleDrop}
          onDragOver={() => this.setState({ drag: true })}
          onDragLeave={() => this.setState({ drag: false })}
          multiple={true}
        >
          <UploadIcon />
          <span className={styles.dropTitle}>
            {__('dropzone.title.drop-your-file-here')}
          </span>
          <Dropdown
            portal
            top={28}
            right={0}
            name={'product_add_files_' + flyout.id}
            wrapperClassName={styles.addFilesDropdownWrapper}
            dropdownClassName={styles.addFilesDropdown}
            content={
              <div className={styles.addFilesMenu}>
                <div
                  className={styles.addFilesOption}
                  onClick={this._openLinkExistingFilesWizard}
                >
                  {__('products.flyout.files.browse-from-volum3')}
                </div>
                <div
                  className={styles.addFilesOption}
                  onClick={this._openUploadPicker}
                >
                  {__('products.flyout.files.upload-new')}
                </div>
              </div>
            }
          >
            <span className={styles.dropSubtitle}>
              {__('products.flyout.files.add-files')}
            </span>
          </Dropdown>
        </ReactDropzone>
        {/* <ReactDropzone
          className={classNames(
            styles.dropzone,
            _.get(this.state, 'drag') && styles.drag
          )}
          onDrop={this._handleDrop}
          onDragOver={() => this.setState({ drag: true })}
          onDragLeave={() => this.setState({ drag: false })}
          multiple={true}
        >
          <UploadIcon />
          <span className={styles.dropTitle}>
            {__('dropzone.title.drop-your-file-here')}
          </span>
          <span className={styles.dropSubtitle}>
            {__('dropzone.title.or-select')}
          </span>
        </ReactDropzone> */}

        {/* Clickboard files */}
        {!_.isEmpty(files) && (
          <Form className={styles.clickboardFiles} onSubmit={this.handleSubmit}>
            {_.map(files, (row, i) => {
              const key = _.toNumber(i);
              return (
                <div className={styles.fileRow} key={key}>
                  <div className={styles.left}>
                    <FilePreview
                      onDownloadFile={this._downloadFile}
                      row={row.file}
                      lightbox_images={lightbox_files}
                    />
                  </div>

                  <div className={styles.right}>
                    <div className={styles.select}>
                      <Select
                        placeholder={__('products.flyout.select-file-category')}
                        // label={__('products.flyout.file-category')}
                        input={{
                          value:
                            this.state.files && this.state.files[i]?.category
                              ? this.state.files[i].category
                              : '',
                          onChange: (value) => {
                            this.setState({
                              files: {
                                ...this.state.files,
                                [key]: {
                                  ...this.state.files[key],
                                  category: value,
                                },
                              },

                              category_errors: _.filter(
                                category_errors,
                                (error) => error != key
                              ),
                            });
                          },
                          onBlur: () =>
                            this.setState({
                              active_category: { [key]: false },
                            }),
                          onFocus: () =>
                            this.setState({ active_category: { [key]: true } }),
                        }}
                        meta={{
                          active: active_category && active_category[key],
                          error: _.includes(category_errors, key),
                          touched: _.includes(category_errors, key),
                        }}
                        options={
                          !_.includes(
                            ['jpg', 'jpeg', 'png'],
                            _.toLower(row.file.ext)
                          )
                            ? _.filter(
                                categories,
                                (category) =>
                                  !_.includes(
                                    [
                                      'thumbnail',
                                      'product',
                                      'drawing',
                                      'ambient',
                                      'technical',
                                      'tileable',
                                    ],
                                    category.value
                                  )
                              )
                            : categories
                        }
                        noSort
                        top={28}
                        searchable
                      />
                    </div>
                    <div className={styles.icons}>
                      <DeleteIcon
                        onClick={() => {
                          this.setState(
                            {
                              files: _.filter(files, (file) => file != row),
                            },
                            () => {
                              this.props.change('files', this.state.files);
                            }
                          );
                        }}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
            <div className={styles.addRow}>
              <button onClick={this._uploadFiles} type='button'>
                {__('products.flyout.add-files')}
              </button>
            </div>
          </Form>
        )}
      </div>
    );
  }
}

export default Files;
